// day js
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc' // Import UTC plugin for Day.js
import relativeTime from 'dayjs/plugin/relativeTime' // Import relativeTime plugin for Day.js
import duration from 'dayjs/plugin/duration'
import timezone from 'dayjs/plugin/timezone'
import {
  ALL_COUNTRIES,
  ALL_CURRENCY,
  COUNTRIES,
  COUNTRY_CODE_OPTIONS,
  GLOBAL_FIAT_CURRENCIES,
  LOCAL_COUNTRIES,
  STABLE_COINS,
  swapAssetsNetworks,
  URL_REGEX
} from './constants'
import {
  TREZOR_ADDRESS_VALIDATOR_PACKAGE,
  WALLET_VALIDATOR_PACKAGE
} from './swapassets' // Import the duration plugin for Day.js

// Extend Day.js with the duration plugin
dayjs.extend(duration)
dayjs.extend(utc)
dayjs.extend(relativeTime)
dayjs.extend(timezone)
var WalletValidator = require('multicoin-address-validator')
var TrezorValidator = require('trezor-address-validator')

/* remove $ and , from string and convert to number */
export const FormatAmount = function (val) {
  // Remove currency symbols and commas
  const cleanedVal = val.replace(/[$₦₵£€₣,]/g, '')

  // Remove "CFA" if it's present and other characters
  const amount = cleanedVal.replace(/CFA/g, '')

  return parseFloat(amount)
}
export const MaskWalletAddressTwo = function (val) {
  // Don't mask string with less than 14 characters so that we don't
  // had unneccessary ellipses to the string
  if (val.length < 14) {
    return val
  }
  if (val) {
    return val.substring(0, 5) + '...' + val.slice(-8)
  }
}
export const SortTimeHandler = (data, time, sortDirection) => {
  if (sortDirection === 'default') {
    return data
  } else {
    data.sort((x, y) => {
      x = new Date(x[time])
      y = new Date(y[time])
      return sortDirection === 'desc' ? x - y : y - x
    })
    return data
  }
}
export const sortAmountHandler = (data, amount, sortDirection) => {
  if (sortDirection === 'default') {
    return data
  }
  return data.sort((a, b) => {
    const aAmount = a[amount]
    const bAmount = b[amount]

    if (sortDirection === 'asc') {
      return aAmount - bAmount
    } else {
      return bAmount - aAmount
    }
  })
}
export const SortNameHandler = (data, name, sortDirection) => {
  if (sortDirection === 'default') {
    return data
  } else if (sortDirection === 'asc') {
    const newData = data.sort((a, b) => {
      const aName = a[name].toUpperCase()
      const bName = b[name].toUpperCase()
      if (aName < bName) {
        return -1
      }
      if (aName > bName) {
        return 1
      }
      return 0
    })
    return newData
  } else {
    const newData = data.sort((a, b) => {
      const aName = a[name].toUpperCase()
      const bName = b[name].toUpperCase()
      if (aName > bName) {
        return -1
      }
      if (aName < bName) {
        return 1
      }
      return 0
    })
    return newData
  }
}
export const sortAmountHandlerWithDoubleParams = (arr, sortDirection) => {
  if (sortDirection === 'default') {
    return arr
  }
  arr.sort((a, b) => {
    const volumeA = a.amount ? a.amount.amount : 0
    const volumeB = b.amount ? b.amount.amount : 0
    if (sortDirection === 'asc') {
      return volumeA - volumeB
    } else {
      return volumeB - volumeA
    }
  })

  return arr
}
export const AddComma = function (val) {
  return val.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const ParseMoney = function (val) {
  if (val) {
    if (noAfterDecimal(val) > 3) {
      val = val.toFixed(3)
    }
    return `$${AddComma(val.toString())}`
  } else {
    return '$0'
  }
}
export const ValidateInput = (rule, value, callback) => {
  // This function validates strings and allows the use of compound names such as 'Mariam-marie, and commas'
  // Regular expression to check for multiple whitespaces
  const multipleWhitespaceReg = /\s{2,}/
  // Regular expression to allow alphanumeric characters, spaces, commas, hyphens
  const allowedCharsReg = /^[0-9a-zA-Z@#$%&()^,\s.-]+$/
  if (value === '') {
    callback()
  } else if (multipleWhitespaceReg.test(value)) {
    callback(new Error('Multiple whitespace not allowed'))
  } else if (!allowedCharsReg.test(value)) {
    callback(new Error('Please enter a valid input'))
  } else {
    callback()
  }
}
export const ValidateKycInput = (rule, value, callback) => {
  // Regular expression to check for multiple whitespaces
  const multipleWhitespaceReg = /\s{2,}/

  const allowedCharsReg = /^[0-9a-zA-Z&/|(),\s.-]+$/
  if (multipleWhitespaceReg.test(value)) {
    callback(new Error('Multiple whitespace not allowed'))
  } else if (!allowedCharsReg.test(value)) {
    callback(new Error('Please enter a valid input'))
  } else {
    callback()
  }
}
export const ValidateRoutingNumber = (rule, value, callback) => {
  // Regular expression to check for whitespaces
  const multipleWhitespaceReg = /\s{1,}/
  // Regular expression to allow alphanumeric characters, spaces, commas, hyphens
  // the input "1354252" is accepted
  const allowedCharsReg = /^[0-9\s-]+$/
  if (value === '' || value === undefined) {
    callback()
  } else if (multipleWhitespaceReg.test(value)) {
    callback(new Error('Whitespace not allowed'))
  } else if (!allowedCharsReg.test(value)) {
    callback(new Error('Please enter a valid input'))
  } else if (value.length > 9) {
    callback(new Error('Routing number must not exceed 9 digits'))
  } else {
    callback()
  }
}
export const ValidateText = (rule, value, callback) => {
  // Regular expression to check for multiple whitespaces
  const multipleWhitespaceReg = /\s{2,}/
  // Regular expression to allow alphabets, space and hyphen only
  const allowedCharsReg = /^[a-zA-Z\s-]+$/
  if (value === '') {
    callback()
  } else if (multipleWhitespaceReg.test(value)) {
    callback(new Error('Multiple whitespace not allowed'))
  } else if (!allowedCharsReg.test(value)) {
    callback(new Error('Please enter a valid input'))
  } else {
    callback()
  }
}
export const ValidateSingleSpace = (rule, value, callback) => {
  const singleWhitespaceReg = /\s{1,}/
  if (value === '') {
    callback()
  } else if (singleWhitespaceReg.test(value)) {
    callback(new Error('Whitespace not allowed'))
  } else {
    callback()
  }
}
export const ValidateSwiftCode = (rule, value, callback) => {
  // Regular expression to check for whitespaces
  const multipleWhitespaceReg = /\s{1,}/
  // Regular expression to allow alphanumeric characters, spaces, commas, hyphens
  // the input "star-girl" is accepted
  const allowedCharsReg = /^[0-9a-zA-Z\s-]+$/
  if (value === '') {
    callback()
  } else if (multipleWhitespaceReg.test(value)) {
    callback(new Error('Whitespace not allowed'))
  } else if (!allowedCharsReg.test(value)) {
    callback(new Error('Please enter a valid input'))
  } else {
    callback()
  }
}
export const GetCountryName = (currency) => {
  if (currency === 'USD') {
    return 'United States '
  } else if (currency === 'GBP') {
    return 'UK'
  } else if (currency === 'EUR') {
    return 'Europe'
  }
}

export const getRGBColor = (hex, type) => {
  const color = hex.replace(/#/g, '')
  // rgb values
  var r = parseInt(color.substr(0, 2), 16)
  var g = parseInt(color.substr(2, 2), 16)
  var b = parseInt(color.substr(4, 2), 16)

  return `--color-${type}: ${r}, ${g}, ${b};`
}

export const GetCountryDetails = function (val) {
  const details = COUNTRIES.find((country) => country.name === val)
  return details || { name: val }
}

export const GetCountryCodeName = function (val) {
  const details = COUNTRY_CODE_OPTIONS.find(
    (countryCode) => countryCode.value === val
  )
  return details.name ? details.name : ''
}

export const GetCountryFullName = function (val) {
  if (!val) {
    return ''
  }

  if (val.length <= 3) {
    const fullName = COUNTRIES.find((country) => country.shortCode === val)
    return fullName
      ? fullName.name.charAt(0).toUpperCase() +
          fullName.name.slice(1).toLowerCase()
      : val
  } else {
    return val
  }
}

export const ConvertValueToXDP = function (value, x) {
  if (noAfterDecimal(parseFloat(value)) > x) {
    value = value.toFixed(x)
    return value
  } else {
    return value
  }
}
export const ParseLocalTime = function (val) {
  // serverDate return 2022-11-16T08:30:23.297963+01:00
  if (val) {
    const modifiedParsedTime = dayjs(val).subtract(1, 'hour')

    const hour = modifiedParsedTime.format('HH')
    const minute = modifiedParsedTime.format('mm')
    const meridiem = modifiedParsedTime.format('A')
    return `${hour}:${minute} ${meridiem}`
  }
}

export const parseBatchDate = function (val) {
  // serverDate return 2022-07-04T18:10:15.390Z
  // function gets the YYYY-MM-DD date, '2022-07-04'
  if (val) {
    const newVal = val.slice(0, 10)
    return newVal
  }
}
export const ParseTime = function (val) {
  // serverDate return 2022-07-04T18:10:15.390Z
  // function gets the HH:MM:SS date, '18:10:15'
  if (val) {
    const newVal = val.slice(11, 19)
    return newVal
  }
}

export const ParseLocalToUsd = function (val, exchangeRate) {
  let total
  if (Number(val)) {
    total = parseFloat(val / exchangeRate).toFixed(2)
  }
  return total || 0
}
export const ParseMoneyUsdc = function (val) {
  if (val) {
    if (noAfterDecimal(val) > 3) {
      val = val.toFixed(3)
    }
    return `${AddComma(val.toString())} USDC`
  } else {
    return '0 USDC'
  }
}
export const GetCurrencyCountry = function (val) {
  let countryFlag = ''
  // Check if currency exists in our currency array
  const currencyDetails = COUNTRIES.find(
    (c) => c.currency === val || c.shortCode === val
  )
  if (currencyDetails) {
    countryFlag = currencyDetails.name
  } else {
    // If currency doesn't exist, assume val is a country code
    const countryDetails = ALL_COUNTRIES.find((c) => c.code2 === val)
    if (countryDetails) {
      // Convert country name to lowercase and replace spaces with dashes, so Ivory Coast becomes ivory-coast and we can use this in our currency icons component
      countryFlag = countryDetails.name.toLowerCase().replace(/\s+/g, '-')
    } else {
      // If not found, return an empty string
      countryFlag = ''
    }
  }
  return countryFlag
}

export const GetCurrencyAndCountry = function (val) {
  const details = COUNTRIES.find((country) => country.currency === val)
  return details ? details.currencyFull : ''
}
export const GetNetworkFullName = function (val) {
  const networkObj = swapAssetsNetworks.find(
    (network) => network.networkShortName === val
  )
  return networkObj ? networkObj.network : ''
}
export const GetNetworkCode = function (val) {
  const networkObj = swapAssetsNetworks.find(
    (network) => network.networkShortName === val
  )
  return networkObj ? networkObj.code : ''
}
export const ParseMoneyAsset = function (val, asset) {
  if (val) {
    if (noAfterDecimal(val) > 3) {
      val = TruncateDecimals(val)
    }
    return `${AddComma(val.toString())} ${asset}`
  } else {
    return `0 ${asset}`
  }
}
export const TruncateDecimals = function (val) {
  if (val) {
    return Math.trunc(val * 100) / 100
  }
}
export const GetCurrencyDetails = function (val) {
  const details = COUNTRIES.find((country) => country.currency === val)
  return details || { name: val }
}
export const ParseMoneyAll = function (amount, country) {
  if ((amount || amount === 0) && country) {
    const currencyDetails = GetCurrencyDetails(country)
    return currencyDetails.network
      ? ParseMoneyAsset(amount, currencyDetails.currency)
      : ParseMoneyLocal(amount, currencyDetails.symbol)
  } else {
    return amount || 0
  }
}
export const ParseMoneyNaira = function (val) {
  if (val) {
    if (noAfterDecimal(val) > 3) {
      val = val.toFixed(2)
    }
    return `₦${AddComma(val.toString())}`
  } else {
    return '₦0'
  }
}
export const ParseMoneyCedis = function (val) {
  if (val) {
    if (noAfterDecimal(val) > 3) {
      val = val.toFixed(2)
    }
    return `₵${AddComma(val.toString())}`
  } else {
    return '₵0'
  }
}
export const ParseMoneyLocal = function (amount, symbol) {
  if (amount) {
    if (noAfterDecimal(amount) > 3) {
      amount = TruncateDecimals(amount)
    }
    return `${symbol}${AddComma(amount.toString())}`
  } else {
    return `${symbol}0`
  }
}
export const getXDatesFromToday = function (number) {
  const dates = []
  for (let i = 1; i <= number; i++) {
    const date = dayjs().subtract(i, 'day').format('YYYY-MM-DD')
    dates.push(date)
  }
  return dates.reverse()
}

export const parseAmountTo3DP = function (val) {
  if (val) {
    if (noAfterDecimal(val) > 3) {
      val = val.toFixed(3)
    }
    return AddComma(val.toString())
  } else {
    return 0
  }
}

export const noAfterDecimal = function (num) {
  if (num) {
    if (Number.isInteger(num)) {
      return 0
    }
    return num?.toString()?.split('.')[1]
      ? num.toString().split('.')[1].length
      : 0
  } else {
    return 0
  }
}
export const digitsAfterDecimal = function (num) {
  if (num) {
    if (Number.isInteger(num)) {
      return ''
    }
    if (noAfterDecimal(num) > 3) {
      num = num.toFixed(3)
    }
    return parseInt(num.toString().split('.')[1]) === 0
      ? ''
      : num.toString().split('.')[1]
  } else {
    return ''
  }
}
export const digitsBeforeDecimal = function (num) {
  if (num) {
    if (Number.isInteger(num)) {
      return num
    }
    if (noAfterDecimal(num) > 3) {
      num = num.toFixed(3)
    }
    return parseInt(num.toString().split('.')[0])
  } else {
    return 0
  }
}
export const expectedInterestSeconds = function (apyValue, balance) {
  const now = dayjs()
  const timeNow = dayjs().format('YYYY-MM-DDTHH:mm:ss')
  const timeDifference = dayjs().diff(now.startOf('day'), 'second')
  // since interested is compounded daily n = 365
  const daysInAYear = 365
  const totalDailySeconds = 86400
  const dailyRate = Math.pow(apyValue / 100 + 1, 1 / daysInAYear) - 1
  const interestDaily = balance * Math.pow(1 + dailyRate, 1) - balance
  const newBalance =
    (interestDaily / totalDailySeconds) * timeDifference + balance
  return newBalance
}
export const expectedInterestYears = function (apyValue, duration, balance) {
  // since interested is compounded daily n = 365
  const daysInAYear = 365
  const dailyRate = Math.pow(apyValue / 100 + 1, 1 / daysInAYear) - 1
  const cInterest = balance * Math.pow(1 + dailyRate, duration * daysInAYear)
  const interest = cInterest - balance
  return interest
}
export const ParseServerDates = function (val) {
  // example of what the backend returns as dates: 2020-08-16 00:54:20.709923 +0000 +0000
  let result = ''
  if (val) {
    let count = 0
    val.split(' ').forEach((v) => {
      if (count < 2) {
        if (count === 1) {
          v =
            v.split(':')[0] +
            ':' +
            v.split(':')[1] +
            ':' +
            v.split(':')[2].substring(0, 2)
        }
        result += v + ' '
      }
      count++
    })
  }
  return result
}

export const MaskWalletAddress = function (val) {
  if (val) {
    return val.substring(0, 5) + '....................' + val.substring(38)
  }
}
export const MaskBearerToken = function (val) {
  const tenantName = process.env.VUE_APP_TENANT_NAME
  if (val) {
    return tenantName.toUpperCase() + '***********' + val.substring(150)
  }
}
export const MaskPublicKey = function (val) {
  const tenantName = process.env.VUE_APP_TENANT_NAME
  if (val) {
    return tenantName.toUpperCase() + '***********' + val.substring(25)
  }
}
export const MaskID = function (val) {
  if (val.length <= 10) {
    return val
  } else {
    return val.substring(0, 10) + '...'
  }
}
export const FormatServerName = function (val) {
  if (val) {
    const formatName = val
      .split('_')
      .map((val) => val.charAt(0).toUpperCase() + val.slice(1))
      .join(' ')
    return formatName
  }
}

export const StatusClass2 = function (status) {
  if (
    status === 'pending' ||
    status === 'processing' ||
    status === 'awaiting_business_approval'
  ) {
    return 'border border-yellow-40 bg-yellow-50 text-yellow-60'
  } else if (
    status === 'cancelled' ||
    status === 'failed' ||
    status === 'unapproved' ||
    status === 'refunded'
  ) {
    return 'border border-red-1 bg-red-3 text-red-5'
  } else if (
    status === 'completed' ||
    status === 'successful' ||
    status === 'approved' ||
    status === 'recurring'
  ) {
    return 'bg-green-6 text-green-5 border border-green-1'
  }
}
export const StatusClass = function (status) {
  switch (status) {
    case 'pending':
    case 'awaiting_approval':
      return 'text-yellow-10 bg-yellow-30'
    case 'awaiting_business_approval':
      return 'text-yellow-10 bg-yellow-30'
    case 'cancelled':
    case 'failed':
    case 'refunded':
    case 'deactivated':
    case 'returned':
      return 'bg-red-4 text-red-1'
    case 'processing':
      return 'bg-yellow-7 text-yellow-8'
    case 'completed':
    case 'successful':
    case 'approved':
    case 'recurring':
    case 'active':
      return 'bg-green-4 text-green-1'
    case 'settled':
      return 'text-primary bg-red-3'
    case 'initiated':
    case 'unsettled':
      return 'text-root-5 bg-gray-1'
    case 'inactive':
      return 'text-gray-muted bg-border-color'
    case 'frozen':
      return 'text-blue-2 bg-blue-60'
    case 'disapproved':
      return 'bg-red-4 text-red-1'
    default:
      return 'bg-gray-5 text-gray-600'
  }
}
export const convertDashedString = function (val) {
  const words = val.split('-')
  const capitalizedWords = words.map((word) => {
    return word.charAt(0).toUpperCase() + word.slice(1)
  })
  return capitalizedWords.join(' ')
}
export const GetTransferType = function (val) {
  let transferType
  if (STABLE_COINS.some((stableCoin) => stableCoin.currency === val)) {
    transferType = 'Asset Transfer'
  } else if (LOCAL_COUNTRIES.some((currency) => currency.currency === val)) {
    transferType = 'Local Transfer'
  } else if (
    GLOBAL_FIAT_CURRENCIES.some((currency) => currency.currency === val)
  ) {
    transferType = 'Fx Transfer'
  }
  return transferType
}
export const ParseNetworkName = function (networkType) {
  switch (networkType) {
    case 'erc20':
      return 'Ethereum'
    case 'Ethereum':
      return 'Ethereum'
    default:
      return networkType
  }
}
export const DaysAgo = function (date) {
  const targetDate = dayjs(date).format('YYYY-MM-DD')
  const days = dayjs().diff(targetDate, 'day')
  return days > 1 ? days + ' Days' : days + ' Day'
}

export const ValidateWallet = function (address, network, validator) {
  var isValid = false
  switch (validator) {
    case null:
      return false
    case WALLET_VALIDATOR_PACKAGE:
      isValid = WalletValidator.validate(address, network.toLowerCase())
      break
    case TREZOR_ADDRESS_VALIDATOR_PACKAGE:
      isValid = TrezorValidator.validate(address, network.toLowerCase())
      break
    default:
      isValid = false
  }

  return isValid
}

export const ParseRelativeTime = function (timeToPick) {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const dateTime = dayjs(timeToPick).tz(timezone)

  return dateTime.from(dayjs().tz(timezone))
}

export const RemoveNonDigitAndDecimal = function (inputString) {
  return inputString.replace(/[^\d.]/g, '')
}
export function AddZeroPrefix (val, digitCount) {
  let count = val.toString().length
  let result = val
  while (count < digitCount) {
    result = `0${result}`
    count++
  }
  return result
}
export const ParseAmount = function (val) {
  // this function parses the  amount i.e (adds commas and allows decimals)
  const stringValue = val.toString()
  const [integerPart, decimalPart] = stringValue.split('.')

  const formattedIntegerPart = integerPart
    .replace(/\D/g, '')
    .replace(/^0+/g, '')
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  const formattedValue =
    decimalPart !== undefined
      ? `${formattedIntegerPart}.${decimalPart}`
      : formattedIntegerPart

  return formattedValue
}

export const GetMinutesAndSecondsFromMilliseconds = (milliseconds) => {
  let minutes = ''
  let seconds = ''
  const duration = dayjs.duration(milliseconds)

  // set minutes from time left
  // append 0 if number is less 10 : 1 formats as 01
  minutes =
    duration.minutes() > 9 ? '' + duration.minutes() : '0' + duration.minutes()

  // set seconds from time left - minutes
  // append 0 if number is less 10 : 1 formats as 01
  seconds =
    duration.seconds() > 9 ? '' + duration.seconds() : '0' + duration.seconds()

  return [minutes, seconds]
}

export const GetTimeDifferenceFromNow = (time) => {
  const timeNow = dayjs().format('YYYY-MM-DD HH:mm:ss')
  const formattedTime = dayjs(time, 'YYYY-MM-DD HH:mm:ss.SSSSSSSSS Z').utc()
  const timeDifference = formattedTime.diff(timeNow, 'millisecond')
  return timeDifference
}

export function appendMetaTags () {
  // This function creates meta tags for the app and appends them onDomContentLoaded in main.js
  const metaDescription = process.env.VUE_APP_META_DESCRIPTION
  const metaImage = process.env.VUE_APP_META_IMAGE
  const metaUrl = process.env.VUE_APP_URL
  const metaTitle = process.env.VUE_APP_TENANT_TITLE

  // Each object represents a meta tag and it's attributes
  const metaAttributes = () => [
    { property: 'description', content: metaTitle, name: metaDescription },
    { property: 'og:title', content: metaTitle, name: 'og:title' },
    {
      property: 'og:description',
      content: metaDescription,
      name: 'og:description'
    },
    { property: 'og:image', content: metaImage, name: 'og:image' },
    { property: 'og:url', content: metaUrl, name: 'og:url' },
    { property: 'twitter:title', content: metaTitle, name: 'twitter:title' },
    {
      property: 'twitter:description',
      content: metaDescription,
      name: 'twitter:description'
    },
    { property: 'twitter:image', content: metaImage, name: 'twitter:image' },
    { property: 'twitter:card', content: 'summary', name: 'twitter:card' }
  ]
  // This is a self invoking function expression
  // It creates each meta tag using the attributes specified in metaAttributes
  ;(function () {
    for (let tag = 0; tag < metaAttributes().length; tag++) {
      const metaTag = document.createElement('meta')
      metaTag.setAttribute('property', metaAttributes()[tag].property)
      metaTag.setAttribute('content', metaAttributes()[tag].content)
      document.head.appendChild(metaTag)
    }
  })()
}

export function truncateString (string, length) {
  if (string) {
    if (string.length > length) {
      return string.slice(0, length) + '...'
    } else {
      return string
    }
  } else {
    return ''
  }
}
export function FormatDate (date) {
  const dateOnly = date.split('T')[0]
  return dateOnly
}

export const getPlaceholderPhoneNumber = (currency) => {
  let placeholder = ''
  switch (currency) {
    case ALL_CURRENCY.GHS:
      placeholder = '(0)902 234 567'
      break
    case ALL_CURRENCY.XAF:
      placeholder = '902 234 567'
      break
    case ALL_CURRENCY.XOF:
      placeholder = '0902 234 567'
      break
    default:
      placeholder = '902 234 568'
  }
  return placeholder
}

// todo write test for this guy
export const FormatCamelCase = (key) => {
  return key
    .replace(/([a-z])([A-Z])/g, '$1 $2') // Insert a space before each uppercase letter
    .replace(/^./, (str) => str.toUpperCase()) // Capitalize the first letter
}
/**
 * Copies all values of an object to the clipboard and shows a notification.
 * @param {Object} details - The object containing details to be copied.
 * @param {Object} notify - The notification object for showing success or error messages.
 * @returns {Promise<void>}
 */
export const CopyAllHandler = async (details, notify) => {
  const filteredDetails = Object.entries(details)
    .filter(
      ([key, value]) => value !== null && value !== undefined && value !== ''
    )
    .map(([key, value]) => `${FormatCamelCase(key)}: ${value}`)
  const textToCopy = filteredDetails.join('\n')
  try {
    await navigator.clipboard.writeText(textToCopy)
    notify.success({
      title: 'Details copied successfully!'
    })
  } catch (err) {
    notify.error('Error copying to clipboard!')
  }
}
export const ValidateWebsiteUrl = (rule, value, callback) => {
  if (!URL_REGEX.test(value) && value !== '') {
    callback(new Error('Please enter a valid website url'))
  } else {
    callback()
  }
}

export const IsValidIP = (ip) => {
  const ipv4Regex =
    /^(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])$/
  const ipv6Regex =
    /^(([0-9a-fA-F]{1,4}:){7}([0-9a-fA-F]{1,4}|:)|(([0-9a-fA-F]{1,4}:){6}(:[0-9a-fA-F]{1,4}|((25[0-5]|(2[0-4]|1[0-9]|[1-9]?)?[0-9])\.){3}(25[0-5]|(2[0-4]|1[0-9]|[1-9]?)?[0-9])|:))|(([0-9a-fA-F]{1,4}:){5}(((:[0-9a-fA-F]{1,4}){1,2})|:|(((:[0-9a-fA-F]{1,4})?:)((25[0-5]|(2[0-4]|1[0-9]|[1-9]?)?[0-9])\.){3}(25[0-5]|(2[0-4]|1[0-9]|[1-9]?)?[0-9]))))|(([0-9a-fA-F]{1,4}:){4}(((:[0-9a-fA-F]{1,4}){1,3})|((:[0-9a-fA-F]{1,4})?:)((25[0-5]|(2[0-4]|1[0-9]|[1-9]?)?[0-9])\.){3}(25[0-5]|(2[0-4]|1[0-9]|[1-9]?)?[0-9])|:))|(([0-9a-fA-F]{1,4}:){3}(((:[0-9a-fA-F]{1,4}){1,4})|((:[0-9a-fA-F]{1,4}){0,2}:)((25[0-5]|(2[0-4]|1[0-9]|[1-9]?)?[0-9])\.){3}(25[0-5]|(2[0-4]|1[0-9]|[1-9]?)?[0-9])|:))|(([0-9a-fA-F]{1,4}:){2}(((:[0-9a-fA-F]{1,4}){1,5})|((:[0-9a-fA-F]{1,4}){0,3}:)((25[0-5]|(2[0-4]|1[0-9]|[1-9]?)?[0-9])\.){3}(25[0-5]|(2[0-4]|1[0-9]|[1-9]?)?[0-9])|:))|(([0-9a-fA-F]{1,4}:){1}(((:[0-9a-fA-F]{1,4}){1,6})|((:[0-9a-fA-F]{1,4}){0,4}:)((25[0-5]|(2[0-4]|1[0-9]|[1-9]?)?[0-9])\.){3}(25[0-5]|(2[0-4]|1[0-9]|[1-9]?)?[0-9]))|:))|(::(((:[0-9a-fA-F]{1,4}){1,7})|:|((:[0-9a-fA-F]{1,4}){0,5}:)((25[0-5]|(2[0-4]|1[0-9]|[1-9]?)?[0-9])\.){3}(25[0-5]|(2[0-4]|1[0-9]|[1-9]?)?[0-9])))$/
  return ipv4Regex.test(ip) || ipv6Regex.test(ip)
}

export const GetStatesForCountry = (countryCode) => {
  return (
    ALL_COUNTRIES.find((country) => country.code2 === countryCode)?.states || []
  )
}

export const DecideTransactionSourceTag = (isExternalAPi) => {
  return isExternalAPi ? 'API' : 'APP'
}
